export const MAIN_ERRORS = {
  DEFAULT_RELOAD: 501,
  DEFAULT: 502,
};



